export default __webpack_public_path__ + "static/media/all-accounts.4c1132d9.png";